import React from 'react';
import PropTypes from 'prop-types';

import Chevron from 'routes/decision-trees/assets/icons/Chevron';

import styles from './styles.module.scss';

export default function ReadMore({ onClick }) {
  return (
    <button className={styles.readMore} onClick={onClick}>
      <span>Read more</span>
      <Chevron />
    </button>
  );
}

ReadMore.propTypes = {
  onClick: PropTypes.func
};
